// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__Fk3YL","uploadWrapper":"style_uploadWrapper__LaVLa","dottedWrapper":"style_dottedWrapper__1rhiC","circle":"style_circle__6X7lF","text":"style_text__1puJ8"};